<template>
    <div>
        <mt-header fixed title="接受委派" class="head" >
           <router-link to="/details" slot="left">
            <mt-button style="font-size:.3rem" icon='back'></mt-button>
           </router-link>
        </mt-header>
          <div class="c_white bg_gray title">委派</div>
          <div class=" bg_white">
            <div class="group c_flex c_flex_between">
                <div class="c_nowrap">{{obj.constructionname}}  /  工长</div>
                <div class="c_nowrap c_blue">{{obj.constructionstate==2?'已接受':'待接受'}}</div>
                <div class="c_nowrap c_gray"></div>
            </div>
            <div class="group c_flex c_flex_between">
                <div class="c_nowrap">{{obj.supervisor}}  /  管家</div>
                <div class="c_nowrap c_blue">{{obj.supervisorstate==2?'已接受':'待接受'}}</div>
                <div class="c_nowrap c_gray"></div>
            </div>
            <div class="group c_flex c_flex_between">
                <div class="c_nowrap">{{obj.surveyname}}  /  勘察</div>
                <div class="c_nowrap c_blue">{{obj.surveystate==2?'已接受':'待接受'}}</div>
                <div class="c_nowrap c_gray"></div>
            </div>
          </div>
          <div class="c_white bg_gray title">是否接受委派</div>
          <div class="opera c_flex c_flex_center">
              <div class="bg_blue c_white" @click="acceptClick('Y')">接受</div>
              <div class="bg_gray c_white" @click="acceptClick('N')">拒绝</div>
          </div>
          <div class="c_white bg_gray title">备注</div>
          <div class="memo">
            <textarea v-model="memo" placeholder="如果拒绝委派，需要拒绝原因" id="" cols="30" rows="10"></textarea>
          </div>
    </div>
</template>
<script>
export default {
      data:function () {
        return {
            billid:'',
            obj:{},
            memo:''
        };
      },
      mounted:function(){
          var obj = JSON.parse(localStorage['obj']);
          if(obj && obj.billid){
            this.billid = obj.billid;
            this.load();
          }
      },
      methods:{
          load:function() {
              var $that = this;
              this.$ajax.get(this.$$api.mobile.getServiceList,{
                search_billid:this.billid,
              },function (res) {
                  if(res.data.success == 'success'){
                    var msg = res.data.detailMsg.data.content;
                    if(msg){
                      $that.obj = msg[0];
                    }
                  }else{
                    $that.$toast(res.data.message);
                  }
              });
          },
        acceptClick:function(isAccept) {
            if(isAccept == 'N'){
              if(!this.memo){
                this.$toast('请填写拒绝原因');
                return;
              }
            }
            var $that = this;
            this.$ajax.post(this.$$api.mobile.isaccept,{
              billid:this.billid,
              isAccept:isAccept,
              memo:this.memo||'',
            },function (res) {
              $that.$router.go(-1);
              var obj = JSON.parse(localStorage['obj']);
              obj.servicestate = isAccept == 'Y' ? 2 : 1;
              localStorage['obj'] = JSON.stringify(obj);
            });
          },
      },
}
</script>
<style scoped>
  .title{
    font-size: 5vw;
    padding: 3.226vw;
  }
  .group{
    padding: 4vw;
    font-size: 4vw;
  }
  .opera div{
    width: 20vw;
    font-size: 4vw;
    text-align: center;
    padding: 3.226vw;
    margin-top:3.226vw;
    margin-bottom:3.226vw;
    white-space: nowrap;
    -webkit-border-radius: 3px;
    -moz-border-radius: 3px;
    border-radius: 3px;
    margin-right: 5vw;
  }
  .memo{
    width: 100%;
    padding: 4vw;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }
  .memo textarea{
    width: 100%;
    font-size: 4vw;
    box-sizing: border-box;
  }
</style>



// WEBPACK FOOTER //
// src/components/update.vue